module.exports = __webpack_public_path__ + "img/48.4fbc3cc5.jpg";